/**
 * BUSY-OVERLAY
 * Blocks every click beneath it while an action is in flight — the parent must be
 * position:relative for it to anchor there.
 */
import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"

export default function BusyOverlay({ text }: { text?: string }) {
  const { t } = useTranslation()

  return (
    <div
      className="flex flex-dcol items-center justify-center"
      style={{ position: "absolute", inset: 0, backgroundColor: "rgba(255,255,255,0.85)", zIndex: 10 }}>
      <FontAwesomeIcon icon={faCircleNotch} spin style={{ fontSize: 32 }} />
      <div className="grey-t text-sm" style={{ marginTop: 8 }}>
        {text ?? t("utils_loading")}
      </div>
    </div>
  )
}
